import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import SignalCellular0BarIcon from '@mui/icons-material/SignalCellular0Bar';
import SignalCellular1BarIcon from '@mui/icons-material/SignalCellular1Bar';
import SignalCellular2BarIcon from '@mui/icons-material/SignalCellular2Bar';
import SignalCellular3BarIcon from '@mui/icons-material/SignalCellular3Bar';
import SignalCellular4BarIcon from '@mui/icons-material/SignalCellular4Bar';
import { Typography } from '@mui/material';

import { Flex } from '../../components';

export const STRENGTH_LOOKUPS = {
  0: 'Very Weak',
  1: 'Weak',
  2: 'Okay',
  3: 'Strong',
  4: 'Very Strong',
};

export const STRENGTH_COLORS = {
  0: 'darkred',
  1: 'red',
  2: 'yellowgreen',
  3: 'green',
  4: 'darkgreen',
};

export const SignalStrength = ({ strength = (f) => f, hideText = false }) => {
  /*
     Strength is measured on a 0 - 4 scale, compliant with the range provided by the MUI library
     */

  const renderIcon = useMemo(() => {
    switch (strength) {
      case 0:
        return <SignalCellular0BarIcon sx={{ color: STRENGTH_COLORS[strength] }} />;
      case 1:
        return <SignalCellular1BarIcon sx={{ color: STRENGTH_COLORS[strength] }} />;
      case 2:
        return <SignalCellular2BarIcon sx={{ color: STRENGTH_COLORS[strength] }} />;
      case 3:
        return <SignalCellular3BarIcon sx={{ color: STRENGTH_COLORS[strength] }} />;
      case 4:
        return <SignalCellular4BarIcon sx={{ color: STRENGTH_COLORS[strength] }} />;
      default:
        return <SignalCellular0BarIcon sx={{ color: STRENGTH_COLORS[0] }} />;
    }
  }, [strength]);

  return (
    <Flex.H sx={{ gap: '8px' }}>
      {renderIcon}
      {!hideText && (
        <Typography sx={{ color: '#000' }}>{STRENGTH_LOOKUPS[strength]}</Typography>
      )}
    </Flex.H>
  );
};

SignalStrength.propTypes = {
  strength: PropTypes.number,
  hideText: PropTypes.bool,
};
